import { render, staticRenderFns } from "./ShopForm.vue?vue&type=template&id=5373feee&scoped=true&"
import script from "./ShopForm.vue?vue&type=script&lang=js&"
export * from "./ShopForm.vue?vue&type=script&lang=js&"
import style0 from "./ShopForm.vue?vue&type=style&index=0&id=5373feee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373feee",
  null
  
)

export default component.exports